

export default function FilterComponent({ setFilter, assignmentMark }) {

    const totalAssignmentMark = assignmentMark.length
    const totalPending = assignmentMark.filter(item => item.status === "pending")?.length
    const totalComplete = assignmentMark.filter(item => item.status === "published")?.length

    return (
        <ul className="assignment-status">
            <li>
                <button onClick={() => setFilter(false)}>Total<span>{totalAssignmentMark}</span></button>
            </li>
            <li>
                <button onClick={() => setFilter("pending")}>Pending<span>{totalPending}</span></button>
            </li>
            <li>
                <button onClick={() => setFilter("published")}>Mark sent<span>{totalComplete}</span></button>
            </li>
        </ul>
    )
};